import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import '../../Typography/src/Heading.js';
import '../../Typography/src/Link.js';
import '../../Typography/src/ListItem.js';
import '../../Typography/src/OrderedList.js';
import { Text } from '../../Typography/src/Text.js';
import '../../Typography/src/UnorderedList.js';
import modules_7f679c10 from '../styles/DoneContent.module.less.js';

const DoneContent = (props) => {
    const { doneContent } = props;
    const cx = useStyles(modules_7f679c10);
    if (doneContent) {
        return doneContent;
    }
    return (React.createElement(Text, { "data-qa": "StepperDoneContent", size: 12, className: cx('label') }, "\u0412\u0441\u0435 \u0433\u043E\u0442\u043E\u0432\u043E"));
};

export { DoneContent };
//# sourceMappingURL=DoneContent.js.map
